import { FC } from 'react';
import { PlaygroundSvgIconProps } from '@utmb/features/races/races-list/playgrounds/PlaygroundIcon';

const MountainIcon: FC<PlaygroundSvgIconProps> = ({ color }) => {
    return (
        <>
            <style jsx>{`
                .cls-1 {
                    fill: ${color};
                }
            `}</style>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.25 45.2" width="34" height="34">
                <path
                    className="cls-1"
                    d="M40.25,45.2,31.42,23,26.57,10.82,20.28,15,14.19,0l-.3,4.67A2.69,2.69,0,0,0,14.76,7l4.4,11.39,6.32-4.15L36.85,42.85,22,42.62h-8.2l-2.33,2.13ZM14.19,0l0,.07,0-.07ZM14.19,0s0,0,0,0l.13.33ZM14.19,0C11,10.8,3.47,33.1.26,43.8c-.08.26,0,0-.26.88,0,0,0,0,0,0l6.84.08h1l0,0,2.49-2.09-.08,0a7.48,7.48,0,0,0-.82,0h-6c3-9.86,8.13-25.21,11.32-35.59l-.49-1.26Z"
                />
            </svg>
        </>
    );
};

export default MountainIcon;
